import { FC } from 'react';
import { Typography } from '@material-tailwind/react';
import Button from 'src/modules/shared/components/atoms/buttons/button';
import {
  PiUser,
  PiLightning,
  PiArchive,
  PiArrowsLeftRight,
} from 'react-icons/pi';
import { UserAssignDropdown } from '../dropdowns/user-assign-dropdown';
import { StatusMoveDropdown } from '../dropdowns/status-move-dropdown';
import { FunnelStatus } from 'src/api/generated';
import Tooltip from 'src/modules/shared/components/atoms/tooltips/tooltip';
import { Text } from 'src/modules/shared/components/atoms/text';

interface BulkActionsProps {
  selectedCount: number;
  onUserAssign: (userId: number | null) => void;
  statuses?: FunnelStatus[];
  onMoveStatus?: (statusId: number) => void;
  onPowerDial?: () => void;
  onArchive?: () => void;
  isLoading?: boolean;
  powerDialingActive?: boolean;
}

export const BulkActions: FC<BulkActionsProps> = ({
  selectedCount,
  onUserAssign,
  statuses,
  onMoveStatus,
  onPowerDial,
  onArchive,
  isLoading = false,
  powerDialingActive,
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className="flex items-center justify-center gap-4 px-6 py-[5.5px] rounded-full bg-primary-50">
      <Typography className="text-sm font-normal text-secondary-600 whitespace-nowrap">
        {/* TODO: check when implementing i18n */}
        {selectedCount} {selectedCount === 1 ? 'seleccionado' : 'seleccionados'}
      </Typography>

      <UserAssignDropdown
        onUserSelect={onUserAssign}
        isLoading={isLoading}
        trigger={
          <div className="flex items-center gap-2 px-0.5">
            <PiUser className="w-4 h-4" />
            {/* TODO: check when implementing i18n */}
            <Typography className="text-sm font-normal">Asignar</Typography>
          </div>
        }
      />

      {onMoveStatus && statuses && statuses.length > 0 && (
        <StatusMoveDropdown
          statuses={statuses}
          onStatusSelect={onMoveStatus}
          isLoading={isLoading}
          trigger={
            <div className="flex items-center gap-2 px-0.5">
              <PiArrowsLeftRight className="w-4 h-4" />
              {/* TODO: check when implementing i18n */}
              <Typography className="text-sm font-normal">Mover</Typography>
            </div>
          }
        />
      )}

      {onArchive && (
        <Button
          variant="primary"
          appearance="outline"
          size="xs"
          onClick={onArchive}
          disabled={isLoading}
          className="rounded-full gap-2 pl-2 pr-3"
          aria-label="Archivar"
        >
          <PiArchive className="w-4 h-4" />
          {/* TODO: check when implementing i18n */}
          <Text size="small" weight="regular">
            Archivar
          </Text>
        </Button>
      )}

      {onPowerDial && (
        <Tooltip
          variant="secondary"
          size="sm"
          content={
            <div className="flex flex-col gap-2 p-2">
              {/* TODO: check when implementing i18n */}
              <Typography className="font-medium text-xs">
                Iniciará una sesión de discado rápido
              </Typography>
              <Typography className="text-xs">
                • Llamará secuencialmente a cada número de cada contacto
              </Typography>
              <Typography className="text-xs">
                • Terminará cuando se complete la cola
              </Typography>
              <Typography className="text-xs">
                • Puedes pausar y reanudar en cualquier momento
              </Typography>
            </div>
          }
        >
          <Button
            variant="primary"
            appearance="outline"
            size="xs"
            onClick={onPowerDial}
            disabled={powerDialingActive}
            className="rounded-full gap-2 pl-2 pr-3"
            aria-label="Iniciar discado"
          >
            <PiLightning className="w-4 h-4" />
            {/* TODO: check when implementing i18n */}
            <Typography className="text-sm font-normal whitespace-nowrap">
              Iniciar discado
            </Typography>
          </Button>
        </Tooltip>
      )}
    </div>
  );
};
